import React, { useEffect, memo, useCallback } from 'react';
import { useQuery, getUserProfileQuery } from '@redlink/services';

export const SupportBlock = memo(() => {
  useEffect(() => {
    var i = 'yGG6nu',
      a = window,
      d = document;
    function g() {
      var g = d.createElement('script'),
        s = 'https://www.goftino.com/widget/' + i,
        l = localStorage.getItem('goftino_' + i);
      g.async = !0;
      g.src = l ? s + '?o=' + l : s;
      d.getElementsByTagName('head')[0].appendChild(g);
    }
    'complete' === d.readyState
      ? g()
      : a.attachEvent
      ? a.attachEvent('onload', g)
      : a.addEventListener('load', g, !1);
  }, []);

  return <></>;
});

export const useSupport = () => {
  const {
    data: { UserProfile: userProfile = {} },
  } = useQuery(getUserProfileQuery, {
    done: () =>
      window.addEventListener('goftino_ready', () => setCurrentUser()),
  });

  const isValidEmail = useCallback((email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }, []);

  const setCurrentUser = useCallback(() => {
    if (!window.Goftino || !userProfile.username) return;

    const isEmail = isValidEmail(userProfile.username);
    window.Goftino.setUser({
      ...(isEmail && { email: userProfile.username }),
      name: `https://redl.ink/${userProfile.currentPage.pageName}`,
      ...(!isEmail && { phone: userProfile.username }),
      ...(userProfile.currentPage.avatar && {
        avatar: userProfile.currentPage.avatar.thumbnailUrl,
      }),
      forceUpdate: true,
    });
  }, [userProfile, isValidEmail]);
};
